import { registerListResourceWithStore } from '@/services/GenericListResourceService'
import store from '@/store'

registerListResourceWithStore('teamSchedules', 'schedule/teams', store)

export default {
  name: 'manage-schedule',
  label: 'Schedule',
  path: 'schedule',
  link: 'schedule',
  props: true,
  icon: 'calendar-alt',
  description: 'View and edit shift schedules.',
  component: () => import('@/components/TabPanel.vue'),
  requirePerm: 'manage_schedule',
  requireGetter: 'scheduleEnabled',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'schedules',
      label: 'Schedules',
      path: 'schedules',
      component: () => import('./Schedules.vue')
        .catch(error => {
          console.error('Failed to route to Schedules', error)
          throw error
        })
    },
    {
      name: 'schedule-teams',
      label: 'Teams',
      title: 'Schedule Teams',
      path: 'teams',
      component: () => import('./ScheduleTeamList.vue')
        .catch(error => {
          console.error('Failed to route to ScheduleTeamList', error)
          throw error
        })
    },
    {
      name: 'manage-schedule-index',
      path: '',
      redirect: { name: 'schedules' }
    }
  ]
}
